import { render, staticRenderFns } from "./CalcAnnotation.vue?vue&type=template&id=04df93a2&scoped=true"
import script from "./CalcAnnotation.vue?vue&type=script&lang=js"
export * from "./CalcAnnotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df93a2",
  null
  
)

export default component.exports